import GET_CONTENT_AUTHORS from "./getContentAuthors"

export default {
  GET_CONTENT_AUTHORS
}
